const getDefaultState = () => {
  return {
    userMediaSettings: {
      cameraOn: true,
      microphoneOn: true,
      speakerOn: false,
      pictureInPictureEnabled: false,
      screenBeingShared: false,
    },
    ownState: {
      brb: {
        value: false,
        enabled: true,
        supportState: "", // e.g. 'coffee', 'tea', 'water', 'bathroom', 'custom'
      },
    },
    partnerState: {
      brb: {
        value: false,
        supportState: "", // e.g. 'coffee', 'tea', 'water', 'bathroom', 'custom'
      },
    },
  };
};

const state = getDefaultState();

// Synchronous
const mutations = {
  RESET_MEDIA_STATES(state) {
    // Merge rather than replace so we don't lose observers
    // https://github.com/vuejs/vuex/issues/1118
    Object.assign(state, getDefaultState());
  },

  SET_RECONNECT_MEDIA_DEVICES(state, values) {
    if (!state || !state.userMediaSettings || !values) return;
    state.userMediaSettings.cameraOn = values.camera;
    state.userMediaSettings.microphoneOn = values.microphone;
    state.userMediaSettings.screenBeingShared = false;
  },

  SET_OWN_STATE(state, data) {
    console.log("this what i doz: ", data);
    if (!data || !data.state || !data.property || (!data.value && data.value !== false)) {
      return console.warn("Missing own state data");
    }
    console.log("state own", state.ownState);
    console.log("state partnerState", state.partnerState);
    state["ownState"][data.state][data.property] = data.value;

    if (data.supportState || data.supportState == "") {
      state["ownState"]["brb"]["supportState"] = data.supportState;
    }
  },

  SET_PARTNER_STATE(state, data) {
    if (!data || !data.state || !data.property || (!data.value && data.value !== false)) {
      return console.warn("Missing partner state data");
    }
    state.partnerState[data.state][data.property] = data.value;

    if (data.supportState || data.supportState == "") {
      state.partnerState[data.state].supportState = data.supportState;
    }
  },

  SET_OWN_SUPPORT_STATE(state, data) {
    if (!data.supportState && data.supportState !== "") {
      return console.warn("Own support icon missing.");
    }
    state.ownState.brb.supportState = data.supportState;
  },

  SET_PARTNER_SUPPORT_STATE(state, data) {
    if (!data.supportState && data.supportState !== "") {
      return console.warn("Partner support icon missing.");
    }
    state.partnerState.brb.supportState = data.supportState;
  },

  RESET_PARTNER_STATES(state) {
    state.partnerState.brb.value = false;
    state.partnerState.brb.supportState = "";
  },

  toggleMediaSetting(state, settingToToggle) {
    console.log("ABOUT TO TOGGLE: ", settingToToggle);
    state.userMediaSettings[settingToToggle] = !state.userMediaSettings[settingToToggle];
  },

  setSpecificMediaSettingState(state, settingData) {
    console.log("ABOUT TO SET: ", settingData);
    state.userMediaSettings[settingData.settingToToggle] = settingData.settingState;
  },
};

// Asynchronous
const actions = {
  resetMediaStates(state) {
    state.commit("RESET_MEDIA_STATES");
  },

  setReconnectMediaDevices(state, values) {
    state.commit("SET_RECONNECT_MEDIA_DEVICES", values);
  },

  setOwnState({ commit }, data) {
    commit("SET_OWN_STATE", data);
  },

  setPartnerState({ commit }, data) {
    console.log("I make here @setPartnerState");
    commit("SET_PARTNER_STATE", data);
  },

  setOwnSupportState({ commit }, data) {
    commit("SET_OWN_SUPPORT_STATE", data);
  },

  setPartnerSupportState({ commit }, data) {
    commit("SET_PARTNER_SUPPORT_STATE", data);
  },

  resetPartnerStates({ commit }) {
    commit("RESET_PARTNER_STATES");
  },

  toggleMediaSetting(state, settingToToggle) {
    state.commit("toggleMediaSetting", settingToToggle);
  },

  setSpecificMediaSettingState(state, settingData) {
    state.commit("setSpecificMediaSettingState", settingData);
  },
};

const mediastates = {
  namespaced: true,

  state,
  mutations,
  actions,
};

export default mediastates;
